import PropTypes from 'prop-types';
import React from 'react';
import {
  FDBox, FDStack, FDDisplayText,
} from '@facet-wealth/design';
import UploadTransitionRecommendedPlannerCSVButton
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionPageHeader/UploadTransitionRecommendedPlannerCSVButton';
import PlannerTransitionSegmentKeyButton
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionPageHeader/PlannerTransitionSegmentKeyButton';

const PlannerTransitionPageHeader = ({
  plannerTransitionHouseholdPageResource,
}) => {
  return (
    <FDBox padding={2}>
      <FDStack direction={'row'} spacing={4}>
        <FDDisplayText size={'sm'} value={plannerTransitionHouseholdPageResource.attr('name')} />
        <PlannerTransitionSegmentKeyButton plannerTransitionHouseholdPageResource={plannerTransitionHouseholdPageResource} />
        <UploadTransitionRecommendedPlannerCSVButton plannerTransitionHouseholdPageResource={plannerTransitionHouseholdPageResource} />
      </FDStack>
    </FDBox>
  );
};

PlannerTransitionPageHeader.defaultProps = {
};

PlannerTransitionPageHeader.propTypes = {
  plannerTransitionHouseholdPageResource: PropTypes.object.isRequired,
};

export default PlannerTransitionPageHeader;
